var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { privateHttp } from '../helpers/Http';
import { generateUrl, parseUrlWithPayload, removeSpecialCharacteres, } from '../helpers/Utils';
var urlBase = process.env.REACT_APP_API_BASE_URL;
var getAll = function (organizationId, payload) {
    var url = "".concat(urlBase, "/v1/organization/").concat(organizationId, "/process");
    return privateHttp.get(parseUrlWithPayload(url, payload));
};
var get = function (organizationId, processNumber, processCustomId) { return __awaiter(void 0, void 0, void 0, function () {
    var process, url, result, subjects, videos, authors, defendants, parts, findCauseValueManual, causeValueManual, _a;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return __generator(this, function (_o) {
        switch (_o.label) {
            case 0:
                _o.trys.push([0, 2, , 3]);
                url = "".concat(urlBase, "/v1/process/").concat(organizationId, "/").concat(processNumber);
                if (processCustomId) {
                    url = url + "?resourceId=".concat(processCustomId);
                }
                return [4 /*yield*/, privateHttp.get(url)];
            case 1:
                result = _o.sent();
                subjects = (_b = result.subject) === null || _b === void 0 ? void 0 : _b.split(/[-|></]/).map(function (item) { return item.replace(/[(\d)]/g, '').trim(); });
                videos = (_c = result.session) === null || _c === void 0 ? void 0 : _c.map(function (video) { return ({
                    title: video.tipoAudiencia,
                    audienceDate: video.dataAudiencia,
                    url: video.video,
                }); });
                authors = (_d = result.authors) === null || _d === void 0 ? void 0 : _d.map(function (author) {
                    var _a;
                    return ({
                        name: author.name_author,
                        document: author.document,
                        representatives: (_a = author.representatives) === null || _a === void 0 ? void 0 : _a.map(function (representative) { return ({
                            name: representative.name_author,
                            document: representative.document,
                        }); }),
                    });
                });
                defendants = (_e = result.defendants) === null || _e === void 0 ? void 0 : _e.map(function (defendant) {
                    var _a;
                    return ({
                        name: defendant.name_author,
                        document: defendant.document,
                        representatives: (_a = defendant.representatives) === null || _a === void 0 ? void 0 : _a.map(function (representative) { return ({
                            name: representative.name_author,
                            document: representative.document,
                        }); }),
                    });
                });
                parts = (_f = result.person_custom) === null || _f === void 0 ? void 0 : _f.map(function (item) { return ({
                    name: removeSpecialCharacteres(item.name_person),
                    document: item.document_person,
                    function: item.function_person,
                }); });
                findCauseValueManual = (_g = result.process_organization) === null || _g === void 0 ? void 0 : _g.find(function (item) { return item.organizationId === organizationId; });
                causeValueManual = {
                    value: findCauseValueManual === null || findCauseValueManual === void 0 ? void 0 : findCauseValueManual.vlProcess,
                    updatedBy: {
                        id: findCauseValueManual === null || findCauseValueManual === void 0 ? void 0 : findCauseValueManual.updatedBy,
                    },
                };
                process = {
                    id: result.process_id,
                    number: result.process_number,
                    type: result.type_court,
                    state: result.state,
                    subjects: subjects,
                    causeValue: result.value_claim,
                    causeValueFormatted: result.value_claim_str,
                    causeValueManual: causeValueManual,
                    distributionDate: result.distribution_date,
                    distributionDateFormatted: result.distribution_date_format,
                    jurisdiction: result.jurisdiction,
                    judgingOrgan: result.judging_organ,
                    origin: result.origin,
                    relatedProcesses: result.related_process,
                    isSecret: result.status === 'SECRET',
                    hasVideos: result.has_session,
                    hasResource: result.has_resource,
                    isResource: result.resource,
                    videos: videos,
                    court: {
                        code: (_h = result.court_info) === null || _h === void 0 ? void 0 : _h.code,
                        name: (_j = result.court_info) === null || _j === void 0 ? void 0 : _j.court_name,
                        acronym: (_k = result.court_info) === null || _k === void 0 ? void 0 : _k.court,
                        state: (_l = result.court_info) === null || _l === void 0 ? void 0 : _l.state,
                        region: (_m = result.court_info) === null || _m === void 0 ? void 0 : _m.region,
                    },
                    authors: authors,
                    defendants: defendants,
                    parts: parts,
                    documents: result.documents,
                    part_matches: result.part_matches,
                };
                return [3 /*break*/, 3];
            case 2:
                _a = _o.sent();
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, process];
        }
    });
}); };
var getMovements = function (organizationId, processId, payload) {
    if (payload === void 0) { payload = {}; }
    var url = "".concat(urlBase, "/v1/organization/").concat(organizationId, "/process/").concat(processId, "/moviments");
    return privateHttp.get(parseUrlWithPayload(url, payload));
};
var getMovement = function (organizationId, processId, movementId) {
    return privateHttp.get("".concat(urlBase, "/v1/organization/").concat(organizationId, "/process/").concat(processId, "/moviments?movimentId=").concat(movementId));
};
var getManualMovements = function (organizationId, processId) {
    return privateHttp.get("".concat(urlBase, "/v1/organization/").concat(organizationId, "/process/").concat(processId, "/movimentsmanual"));
};
var uploadManualMovement = function (organizationId, processId, _a) {
    var file = _a.file, date = _a.date, description = _a.description;
    var formData = new FormData();
    formData.append('file', file);
    formData.append('dtMovimentation', date);
    formData.append('description', description);
    return privateHttp.post("".concat(urlBase, "/v1/file/uploadManual/").concat(organizationId, "/process/").concat(processId), formData, {
        headers: {
            'Content-Type': "multipart/form-data; boundary=".concat(formData._boundary),
        },
    });
};
var getMovementsTypes = function (organizationId) {
    return privateHttp.get("".concat(urlBase, "/v1/organization/").concat(organizationId, "/moviments/types"));
};
var getDocumentUrl = function (path) {
    return privateHttp.get("".concat(urlBase, "/v1/url?page=").concat(path));
};
var respondClassification = function (organizationId, movimentId, peopleId, questions) {
    return privateHttp.post("".concat(urlBase, "/v1/organization/").concat(organizationId, "/moviment/").concat(movimentId, "/people/").concat(peopleId), {
        questions: questions,
    });
};
var addToProcess = function (organizationId, peopleId, responsabilityId, processId) {
    return privateHttp.put("".concat(urlBase, "/v1/organization/").concat(organizationId, "/people/").concat(peopleId, "/responsability/").concat(responsabilityId), {
        processId: processId,
    });
};
var deleteToProcess = function (organizationId, movimentId, peopleId) {
    return privateHttp.delete("".concat(urlBase, "/v1/organization/").concat(organizationId, "/moviment/").concat(movimentId, "/people/").concat(peopleId));
};
/**
 * getChecklistGroup
 * ! Deprecated method
 */
var getChecklistGroup = function (organizationId) {
    return privateHttp.get("".concat(urlBase, "/v1/organization/").concat(organizationId, "/checklistgroup"));
};
var getChecklist = function (organizationId, processId) {
    return privateHttp.get("".concat(urlBase, "/v1/organization/").concat(organizationId, "/process/").concat(processId, "/checklist"));
};
var upsertChecklist = function (organizationId, processId, questions) {
    return privateHttp.post("".concat(urlBase, "/v1/organization/").concat(organizationId, "/process/").concat(processId, "/checklist"), {
        questions: questions,
    });
};
var cleanChecklist = function (organizationId, checklistGroupId, processId) {
    return privateHttp.delete("".concat(urlBase, "/v1/organization/").concat(organizationId, "/checklistgroup/").concat(checklistGroupId, "/process/").concat(processId));
};
var updateProcess = function (processNumber) {
    return privateHttp.put("".concat(urlBase, "/v1/process/").concat(processNumber));
};
var getAutos = function (organizationId, processNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var url, items, total, result, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                url = generateUrl(urlBase, "/v1/process/".concat(organizationId, "/").concat(processNumber, "/autos"));
                items = [];
                total = 0;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, privateHttp.get(url)];
            case 2:
                result = _b.sent();
                items = result.map(function (item) { return ({
                    description: item.description,
                    file: item.file,
                    date: item.date_autos,
                    dateFormat: item.date_autos_format,
                }); });
                total = items.length;
                return [3 /*break*/, 4];
            case 3:
                _a = _b.sent();
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/, { items: items, total: total }];
        }
    });
}); };
var getCustomInfo = function (organizationId, processId) { return __awaiter(void 0, void 0, void 0, function () {
    var url, items, total, _a, result, totalItems, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                url = "".concat(urlBase, "/v1/organization/").concat(organizationId, "/process/").concat(processId, "/customfield");
                items = [];
                total = 0;
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                return [4 /*yield*/, privateHttp.get(url)];
            case 2:
                _a = _c.sent(), result = _a.result, totalItems = _a.total;
                items = result.map(function (item) {
                    var _a;
                    return ({
                        id: item.customFieldsOrganization.customFieldId,
                        label: item.customFieldsOrganization.fieldName,
                        value: item.aswner,
                        valueLabel: (_a = item.customFieldsOrganization.customFieldsListValues) === null || _a === void 0 ? void 0 : _a.valueinformation,
                        type: item.customFieldsOrganization.typeFieldsCustom,
                        typeLabel: item.customFieldsOrganization.typeFieldsCustomLabel,
                        createdBy: {
                            id: item.createdBy.id,
                        },
                        updatedBy: {
                            id: item.updatedBy.id,
                        },
                    });
                });
                total = totalItems;
                return [3 /*break*/, 4];
            case 3:
                _b = _c.sent();
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/, { items: items, total: total }];
        }
    });
}); };
var getCustomInfoFields = function (organizationId) { return __awaiter(void 0, void 0, void 0, function () {
    var url, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(urlBase, "/v1/organization/").concat(organizationId, "/customfield/list");
                return [4 /*yield*/, privateHttp.get(url)];
            case 1:
                result = _a.sent();
                return [2 /*return*/, {
                        items: result.map(function (item) { return ({
                            id: item.customFieldId,
                            label: item.fieldName,
                            type: item.typeFieldsCustom,
                            typeLabel: item.typeFieldsCustomLabel,
                            priority: item.priority,
                            required: item.required,
                        }); }),
                    }];
        }
    });
}); };
var getValuesCustomInfoFieldList = function (organizationId, customFieldId) {
    var url = "".concat(urlBase, "/v1/organization/").concat(organizationId, "/customfield/").concat(customFieldId, "/listvalue/list");
    return privateHttp.get(url);
};
var createCustomInfo = function (organizationId, processId, data) {
    var url = "".concat(urlBase, "/v1/organization/").concat(organizationId, "/process/").concat(processId, "/customfield");
    return privateHttp.post(url, { answerCustomFields: data });
};
var editCustomInfo = function (organizationId, processId, data) {
    var url = "".concat(urlBase, "/v1/organization/").concat(organizationId, "/process/").concat(processId, "/customfield");
    return privateHttp.put(url, { answerCustomFields: data });
};
var upsertCauseValue = function (organizationId, processId, _a) {
    var causeValue = _a.causeValue;
    var url = "".concat(urlBase, "/v1/organization/").concat(organizationId, "/process/").concat(processId, "/changevalue");
    return privateHttp.post(url, { valueProcess: causeValue });
};
var parseQSA = function (qsa) {
    var _a, _b, _c, _d;
    return ({
        name: qsa.name || qsa.relatedEntityName,
        documentNumber: qsa.documentNumber || qsa.relatedEntityTaxIdNumber,
        documentType: qsa.documentType || qsa.relatedEntityTaxIdType,
        qualification: {
            level: ((_a = qsa.qualification) === null || _a === void 0 ? void 0 : _a.level) || qsa.relationshipLevel,
            type: ((_b = qsa.qualification) === null || _b === void 0 ? void 0 : _b.type) || qsa.relationshipType,
        },
        active: ((qsa === null || qsa === void 0 ? void 0 : qsa.relationshipsType) === 'CURRENT' && !(qsa === null || qsa === void 0 ? void 0 : qsa.endDate)) ||
            qsa.isCurrentlyActive,
        relationshipId: qsa.relatedEntityTaxIdNumber,
        relationshipType: ((_c = qsa.qualification) === null || _c === void 0 ? void 0 : _c.type) ||
            qsa.relationshipName ||
            (qsa.relationshipType === 'PARTNER' &&
                qsa.relationshipLevel === 'DIRECT' &&
                qsa.relationshipType),
        qsaId: qsa.organizationQSAId,
        qsaRelationId: qsa.organizationQSARelationId || qsa.id,
        // wasAnalyzed: qsa.wasAnalyzed,
        // hasRisk: qsa.hasRisk,
        relations: (_d = qsa.relations) === null || _d === void 0 ? void 0 : _d.map(parseQSA),
        risks: parseRisk(qsa.analizedData || qsa.kycData, qsa.organizationId),
        endDate: qsa.endDate || qsa.relationshipEndDate,
        hasAnalysis: qsa === null || qsa === void 0 ? void 0 : qsa.userPlanConsumeAnalyticsId,
        analysisDate: qsa === null || qsa === void 0 ? void 0 : qsa.userPlanConsumeAnalyticsDate,
        startDate: qsa.startDate || qsa.relationshipStartDate,
        relationshipName: qsa === null || qsa === void 0 ? void 0 : qsa.relationshipName,
    });
};
export var getQSA = function (organizationId, cnpj) { return __awaiter(void 0, void 0, Promise, function () {
    var url, result, organization, relations2, relations;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                url = "".concat(urlBase, "/v1/organizations/").concat(organizationId, "/qsa/").concat(cnpj);
                return [4 /*yield*/, privateHttp.post(url)];
            case 1:
                result = (_b.sent()).result;
                organization = result.items[0];
                relations2 = organization.relations || [];
                relations = relations2.map(function (item) { return (__assign(__assign({}, item), { organizationId: organizationId })); });
                return [2 /*return*/, {
                        result: {
                            qsaId: organization.organizationQSAId,
                            risks: parseRisk(organization.analizedData, organizationId),
                            relations: (_a = relations === null || relations === void 0 ? void 0 : relations.filter(function (item) { var _a; return ((_a = item.qualification) === null || _a === void 0 ? void 0 : _a.name) === 'QSA'; })) === null || _a === void 0 ? void 0 : _a.map(parseQSA),
                            hasAnalysis: organization === null || organization === void 0 ? void 0 : organization.userPlanConsumeAnalyticsId,
                            analysisDate: organization === null || organization === void 0 ? void 0 : organization.userPlanConsumeAnalyticsDate,
                        },
                    }];
        }
    });
}); };
var reduceParsedRelations = function (items) {
    var map = new Map();
    items
        // filtra só os DIRECT + tipos que te interessam
        .filter(function (item) {
        return item.qualification.level === 'DIRECT' &&
            ['OWNERSHIP', 'LEGAL REPRESENTATIVE', 'PARTNER'].includes(item.qualification.type);
    })
        .forEach(function (item) {
        var _a, _b, _c;
        var key = item.documentNumber; // agrupa por documento já “limpo”
        if (!map.has(key)) {
            map.set(key, {
                base: __assign({}, item),
                date: new Set([(_a = item === null || item === void 0 ? void 0 : item.startDate) === null || _a === void 0 ? void 0 : _a.replace('Z', '')]),
                endDate: new Set([(_b = item.endDate) === null || _b === void 0 ? void 0 : _b.replace('Z', '')]),
                active: new Set([item.active]),
                analysisDate: new Set([item.analysisDate]),
                risks: new Set([item.risks]),
                hasAnalysis: new Set([item.hasAnalysis]),
                name: new Set([
                    item.relationshipName === 'OWNER'
                        ? 'DONO(A)'
                        : item.relationshipType === 'PARTNER'
                            ? 'SOCIO'
                            : item.relationshipName,
                ]),
            });
        }
        else {
            map.get(key).date.add(item.startDate.replace('Z', ''));
            map.get(key).endDate.add((_c = item === null || item === void 0 ? void 0 : item.endDate) === null || _c === void 0 ? void 0 : _c.replace('Z', ''));
            map.get(key).active.add(item.active);
            map.get(key).analysisDate.add(item.analysisDate);
            map.get(key).risks.add(item.risks);
            map.get(key).hasAnalysis.add(item.hasAnalysis);
            map
                .get(key)
                .name.add(item.relationshipName === 'OWNER'
                ? 'DONO(A)'
                : item.relationshipType === 'PARTNER'
                    ? 'SOCIO'
                    : item.relationshipName);
        }
    });
    // monta array final mesclando os tipos em uma string só
    return Array.from(map.values()).map(function (_a) {
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        var base = _a.base, date = _a.date, endDate = _a.endDate, active = _a.active, analysisDate = _a.analysisDate, risks = _a.risks, name = _a.name;
        return (__assign(__assign({}, base), { 
            // sobrescreve types, date, endDate, active, analysisDate, risks juntando os tipos distintos
            startDate: (_d = (_c = (_b = Array.from(date)) === null || _b === void 0 ? void 0 : _b.sort(function (a, b) { return new Date(a).getTime() - new Date(b).getTime(); })) === null || _c === void 0 ? void 0 : _c.filter(function (item) { return item !== '0001-01-01T00:00:00'; })[0]) !== null && _d !== void 0 ? _d : '0001-01-01T00:00:00', endDate: (_g = (_f = (_e = Array.from(endDate)) === null || _e === void 0 ? void 0 : _e.sort(function (a, b) { return new Date(b).getTime() - new Date(a).getTime(); })) === null || _f === void 0 ? void 0 : _f.filter(function (item) { return item.slice(0, 4) === '9999'; })[0]) !== null && _g !== void 0 ? _g : (_j = (_h = Array.from(endDate)) === null || _h === void 0 ? void 0 : _h.sort(function (a, b) { return b - a; })) === null || _j === void 0 ? void 0 : _j.filter(function (item) { return item.slice(0, 4) !== '9999'; })[0], active: active.has(true), analysisDate: (_k = Array.from(analysisDate)) === null || _k === void 0 ? void 0 : _k.sort(function (a, b) { return b - a; })[0], risks: (_l = Array.from(risks)) === null || _l === void 0 ? void 0 : _l.sort(function (a, b) { return b - a; })[0], relationshipType: (_m = Array.from(name)) === null || _m === void 0 ? void 0 : _m.sort()[0], relationshipName: (_o = Array.from(name)) === null || _o === void 0 ? void 0 : _o.sort()[0] }));
    });
};
var getQSACpf = function (organizationId, holderId, businessId, documentNumber) { return __awaiter(void 0, void 0, Promise, function () {
    var url, result, parsed;
    var _a, _b, _c, _d, _e, _f, _g;
    return __generator(this, function (_h) {
        switch (_h.label) {
            case 0:
                url = "".concat(urlBase, "/v1/business-relationships/organizations/").concat(organizationId, "/holder/").concat(holderId, "/userPlanUserConsumeBusinessRelationshipsSummary/").concat(businessId);
                return [4 /*yield*/, privateHttp.post(url)];
            case 1:
                result = (_h.sent()).result;
                parsed = (_d = (_c = (_b = (_a = result === null || result === void 0 ? void 0 : result.items) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.businessRelationshipsDetails) === null || _c === void 0 ? void 0 : _c.map(parseQSA)) !== null && _d !== void 0 ? _d : [];
                return [2 /*return*/, {
                        result: {
                            qsaId: (_e = result === null || result === void 0 ? void 0 : result.items[0]) === null || _e === void 0 ? void 0 : _e.id,
                            risks: parseRisk((_f = result === null || result === void 0 ? void 0 : result.items[0]) === null || _f === void 0 ? void 0 : _f.kycData, organizationId),
                            relations: (_g = reduceParsedRelations(parsed)) === null || _g === void 0 ? void 0 : _g.filter(function (item) { return item.relationshipName; }),
                        },
                    }];
        }
    });
}); };
var getQSAFirstItem = function (organizationId, holderId, businessId) { return __awaiter(void 0, void 0, void 0, function () {
    var url, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(urlBase, "/v1/organizations/").concat(organizationId, "/holder/").concat(holderId, "/userPlanConsumeBusinessRelationshipsSummary/").concat(businessId, "/business_relationships");
                return [4 /*yield*/, privateHttp.get(url)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getListQSA = function (holderId, organizationId, consumeId, analysisId, businessId) { return __awaiter(void 0, void 0, Promise, function () {
    var url, result, parsed;
    var _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                url = "".concat(urlBase, "/v1/holder/").concat(holderId, "/organization/").concat(organizationId, "/consumeunique/").concat(consumeId, "/analytics/").concat(analysisId, "/business/").concat(businessId, "/detail");
                return [4 /*yield*/, privateHttp.get(url)];
            case 1:
                result = (_d.sent()).result;
                parsed = (_b = (_a = result === null || result === void 0 ? void 0 : result.businessRelationships) === null || _a === void 0 ? void 0 : _a.map(parseQSA)) !== null && _b !== void 0 ? _b : [];
                return [2 /*return*/, {
                        status: 'success',
                        result: {
                            items: (_c = parsed === null || parsed === void 0 ? void 0 : parsed.map(function (item) {
                                return item.startDate
                                    ? __assign(__assign({}, item), { startDate: item.startDate.replace('Z', '') }) : item;
                            })) === null || _c === void 0 ? void 0 : _c.filter(function (item) { return item.relationshipName; }),
                            total: result.total,
                        },
                    }];
        }
    });
}); };
var getAnalyzeQsa = function (holderId, organizationId, planId, documentType, documentNumber, relationId, retry) { return __awaiter(void 0, void 0, void 0, function () {
    var url, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = generateUrl(urlBase, "/v2/analytics/organizationQSARelations/".concat(relationId), { retry: retry });
                return [4 /*yield*/, privateHttp.post(url, {
                        holderId: holderId,
                        organizationId: organizationId,
                        planId: planId,
                        documentType: documentType,
                        documentNumber: documentNumber,
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getAnalyzeQsaCpfRelation = function (holderId, organizationId, planId, documentType, documentNumber, relationId, retry) { return __awaiter(void 0, void 0, void 0, function () {
    var url, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = generateUrl(urlBase, "/v2/analytics/relationshipsParents/".concat(relationId), { retry: retry });
                return [4 /*yield*/, privateHttp.post(url, {
                        holderId: holderId,
                        organizationId: organizationId,
                        planId: planId,
                        documentType: documentType,
                        documentNumber: documentNumber,
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
        }
    });
}); };
var getQSACPFRelations = function (organizationId, holderId, documentNumber) { return __awaiter(void 0, void 0, void 0, function () {
    var url, result;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                url = "".concat(urlBase, "/v1/relationships-parents");
                return [4 /*yield*/, privateHttp.post(url, {
                        organizationId: organizationId,
                        holderId: holderId,
                        documentNumber: documentNumber,
                    })];
            case 1:
                result = (_b.sent()).result;
                return [2 /*return*/, (_a = result === null || result === void 0 ? void 0 : result.items) === null || _a === void 0 ? void 0 : _a.map(function (item) { return ({
                        qsaId: item.id,
                        relationshipId: item.id,
                        name: item.relatedName,
                        documentNumber: item.relatedTaxIdNumber,
                        documentType: 'CPF',
                        relationshipType: item.relationshipType,
                        relationshipLevel: item.relationshipLevel,
                        qualification: {
                            level: item.relationshipLevel,
                        },
                        active: true,
                        createdAt: item.createdAt,
                        updatedAt: item.updatedAt,
                        risks: parseRisk(item.analyzedData, organizationId),
                        hasAnalysis: item === null || item === void 0 ? void 0 : item.userPlanConsumeUniqueAnalyticsId,
                        organizationId: organizationId,
                        analysisDate: item === null || item === void 0 ? void 0 : item.userPlanConsumeAnalyticsDate,
                    }); })];
        }
    });
}); };
var getQSACPFRelationsRisk = function (organizationId, holderId, organizationQsaId) { return __awaiter(void 0, void 0, void 0, function () {
    var url, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(urlBase, "/v1/relationships-parents/organizations/").concat(organizationId, "/holder/").concat(holderId, "/organizationRelationshipParentDetailId/").concat(organizationQsaId);
                return [4 /*yield*/, privateHttp.post(url, {
                        organizationId: organizationId,
                        holderId: holderId,
                        organizationQsaId: organizationQsaId,
                    })];
            case 1:
                result = (_a.sent()).result;
                return [2 /*return*/, parseRisk(result.items[0], organizationId)];
        }
    });
}); };
var getQSARiskMindmapCPF = function (organizationId, holderId, relationId) { return __awaiter(void 0, void 0, void 0, function () {
    var url, result;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                url = "".concat(urlBase, "/v1/business-relationships/organizations/").concat(organizationId, "/holder/").concat(holderId, "/userPlanUserConsumeBusinessRelationshipsDetail/").concat(relationId);
                return [4 /*yield*/, privateHttp.post(url)];
            case 1:
                result = (_b.sent()).result;
                return [2 /*return*/, parseRisk((_a = result === null || result === void 0 ? void 0 : result.items[0]) === null || _a === void 0 ? void 0 : _a.kycData, organizationId)];
        }
    });
}); };
var getQSACNPJRelations = function (organizationId, organizationQSAId, relationId) { return __awaiter(void 0, void 0, void 0, function () {
    var url, response2, response;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                url = "".concat(urlBase, "/v1/organizations/").concat(organizationId, "/organizationQSA/").concat(organizationQSAId, "/relatedEntityTaxIdNumber/").concat(relationId);
                return [4 /*yield*/, privateHttp.get(url)];
            case 1:
                response2 = _b.sent();
                response = response2.map(function (item) { return (__assign(__assign({}, item), { organizationId: organizationId })); });
                return [2 /*return*/, (((_a = response === null || response === void 0 ? void 0 : response.filter(function (item) { var _a; return ((_a = item.qualification) === null || _a === void 0 ? void 0 : _a.name) === 'QSA'; })) === null || _a === void 0 ? void 0 : _a.map(parseQSA)) || [])];
        }
    });
}); };
// Nova função para buscar dados de KYC de forma mais robusta
var getKYCData = function (organizationId, holderId, documentNumber, documentType, businessId) { return __awaiter(void 0, void 0, Promise, function () {
    var qsaResponse, riskData, riskError_1, error_1;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 10, , 11]);
                qsaResponse = void 0;
                if (!(documentType === 'CNPJ')) return [3 /*break*/, 2];
                return [4 /*yield*/, getQSA(organizationId, documentNumber)];
            case 1:
                qsaResponse = _c.sent();
                return [3 /*break*/, 5];
            case 2: return [4 /*yield*/, getQSAFirstItem(organizationId, holderId, businessId)];
            case 3:
                _c.sent();
                return [4 /*yield*/, getQSACpf(organizationId, holderId, businessId, documentNumber)];
            case 4:
                qsaResponse = _c.sent();
                _c.label = 5;
            case 5:
                if ((_a = qsaResponse === null || qsaResponse === void 0 ? void 0 : qsaResponse.result) === null || _a === void 0 ? void 0 : _a.risks) {
                    return [2 /*return*/, {
                            result: __assign(__assign({}, qsaResponse.result), { relations: qsaResponse.result.relations || [], risks: qsaResponse.result.risks, hasAnalysis: true }),
                        }];
                }
                if (!((_b = qsaResponse === null || qsaResponse === void 0 ? void 0 : qsaResponse.result) === null || _b === void 0 ? void 0 : _b.qsaId)) return [3 /*break*/, 9];
                _c.label = 6;
            case 6:
                _c.trys.push([6, 8, , 9]);
                return [4 /*yield*/, getQSARisk(organizationId, holderId, qsaResponse.result.qsaId)];
            case 7:
                riskData = _c.sent();
                if (riskData) {
                    return [2 /*return*/, {
                            result: __assign(__assign({}, qsaResponse.result), { relations: qsaResponse.result.relations || [], risks: riskData, hasAnalysis: true }),
                        }];
                }
                return [3 /*break*/, 9];
            case 8:
                riskError_1 = _c.sent();
                console.warn('Erro ao buscar riscos específicos:', riskError_1);
                return [3 /*break*/, 9];
            case 9: 
            // Se ainda não há dados, retornar que não foi analisado
            return [2 /*return*/, {
                    result: __assign(__assign({}, qsaResponse.result), { relations: qsaResponse.result.relations || [], risks: null, hasAnalysis: qsaResponse.result.hasAnalysis || false }),
                }];
            case 10:
                error_1 = _c.sent();
                console.warn('Erro ao buscar dados de KYC:', error_1);
                return [2 /*return*/, {
                        result: {
                            risks: null,
                            hasAnalysis: false,
                        },
                    }];
            case 11: return [2 /*return*/];
        }
    });
}); };
var parseRisk = function (data, organizationId) {
    var _a, _b, _c;
    // const problemData = data.result.items[0];
    var result = [];
    var protest = data === null || data === void 0 ? void 0 : data.protest;
    var risk1 = (_a = data === null || data === void 0 ? void 0 : data.additionalDetails) === null || _a === void 0 ? void 0 : _a.IsCurrentlyPresentOnSource;
    var risk2 = (_b = data === null || data === void 0 ? void 0 : data.additionalDetails) === null || _b === void 0 ? void 0 : _b.PEPOccurence;
    var risk3 = (_c = data === null || data === void 0 ? void 0 : data.additionalDetails) === null || _c === void 0 ? void 0 : _c.wasPreviouslySanctioned;
    if (protest && [590, 371, 554, 812, 809, 813, 987].includes(organizationId)) {
        result.push({
            date: protest.data,
            location: protest.protest,
            amount: protest.quantidade,
            value: protest.valor,
            risco: 'Protesto',
        });
    }
    if (risk1 === null || risk1 === void 0 ? void 0 : risk1.hasProblem) {
        result.push({
            date: risk1.startDate,
            source: risk1.details.source,
            reason: risk1.details.type,
            sanctionType: risk1.details.standardizedSanctionType,
            risco: 'IsCurrentlyPresentOnSource',
        });
    }
    if (risk2 === null || risk2 === void 0 ? void 0 : risk2.hasProblem) {
        result.push({
            position: risk2.details.position,
            startDate: risk2.details.startDate,
            endDate: risk2.details.endDate,
            risco: 'PEPOccurence',
        });
    }
    if (risk3 === null || risk3 === void 0 ? void 0 : risk3.hasProblem) {
        result.push({
            date: risk3.startDate,
            source: risk3.details.source,
            reason: risk3.details.type,
            sanctionType: risk3.details.standardizedSanctionType,
            risco: 'wasPreviouslySanctioned',
        });
    }
    var hasAnalyzed = protest !== undefined ||
        risk1 !== undefined ||
        risk2 !== undefined ||
        risk3 !== undefined;
    if (!hasAnalyzed)
        return null;
    return result;
};
var getQSARisk = function (organizationId, holderId, organizationQSAId) { return __awaiter(void 0, void 0, Promise, function () {
    var url, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(urlBase, "/v1/organizations/").concat(organizationId, "/holder/").concat(holderId, "/organizationQSA/").concat(organizationQSAId);
                return [4 /*yield*/, privateHttp.post(url)];
            case 1:
                result = (_a.sent()).result;
                return [2 /*return*/, parseRisk(result.items[0], organizationId)];
        }
    });
}); };
var getQSARelationRisk = function (organizationId, holderId, organizationQSAId, relationId) { return __awaiter(void 0, void 0, Promise, function () {
    var url, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(urlBase, "/v1/organizations/").concat(organizationId, "/holder/").concat(holderId, "/organizationQSA/").concat(organizationQSAId, "/relation/").concat(relationId);
                return [4 /*yield*/, privateHttp.post(url)];
            case 1:
                result = (_a.sent()).result;
                return [2 /*return*/, parseRisk(result.items[0], organizationId)];
        }
    });
}); };
var getAnalyzeQsaCpfMindmap = function (holderId, organizationId, planId, documentType, documentNumber, relationId, retry) { return __awaiter(void 0, void 0, void 0, function () {
    var url, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = generateUrl(urlBase, "/v2/analytics/userPlanConsumeBusinessRelationshipsDetail/".concat(relationId), { retry: retry });
                return [4 /*yield*/, privateHttp.post(url, {
                        holderId: holderId,
                        organizationId: organizationId,
                        planId: planId,
                        documentType: documentType,
                        documentNumber: documentNumber,
                    })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response];
        }
    });
}); };
// Wrapper para buscar dados QSA/KYC
var getQSAWithLogs = function (organizationId, holderId, documentNumber, documentType, businessId) {
    if (businessId === void 0) { businessId = ''; }
    return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getKYCData(organizationId, holderId, documentNumber, documentType, businessId)];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result];
            }
        });
    });
};
export var ProcessService = {
    getAll: getAll,
    get: get,
    getMovements: getMovements,
    getMovement: getMovement,
    getManualMovements: getManualMovements,
    uploadManualMovement: uploadManualMovement,
    getMovementsTypes: getMovementsTypes,
    getDocumentUrl: getDocumentUrl,
    respondClassification: respondClassification,
    addToProcess: addToProcess,
    deleteToProcess: deleteToProcess,
    upsertChecklist: upsertChecklist,
    getChecklistGroup: getChecklistGroup,
    getChecklist: getChecklist,
    cleanChecklist: cleanChecklist,
    updateProcess: updateProcess,
    getAutos: getAutos,
    getCustomInfo: getCustomInfo,
    getCustomInfoFields: getCustomInfoFields,
    getValuesCustomInfoFieldList: getValuesCustomInfoFieldList,
    createCustomInfo: createCustomInfo,
    editCustomInfo: editCustomInfo,
    upsertCauseValue: upsertCauseValue,
    getQSA: getQSA,
    getQSACpf: getQSACpf,
    getQSACPFRelations: getQSACPFRelations,
    getQSACNPJRelations: getQSACNPJRelations,
    getQSARisk: getQSARisk,
    getQSARelationRisk: getQSARelationRisk,
    getQSACPFRelationsRisk: getQSACPFRelationsRisk,
    getAnalyzeQsa: getAnalyzeQsa,
    getAnalyzeQsaCpfRelation: getAnalyzeQsaCpfRelation,
    getKYCData: getKYCData,
    getQSAWithLogs: getQSAWithLogs,
    getQSAFirstItem: getQSAFirstItem,
    getListQSA: getListQSA,
    getQSARiskMindmapCPF: getQSARiskMindmapCPF,
    getAnalyzeQsaCpfMindmap: getAnalyzeQsaCpfMindmap,
};
